import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import ScrollToAnchor from './ScrollToComponent';
import hamburgerMenu from '../assets/hamburger-menu.png'
import './../pg/Global.css';
import './Palette.css';
import './Navbar.css';
import { useSearchParams } from 'react-router-dom';

type NavbarProps = {
};

const Navbar: React.FC<NavbarProps> = () => {
    const [windowWidth, setWindowWidth] = useState(100);
    const [hamburgerVisibe, switchHamburgerVisibility] = useState(true);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const lang = searchParams.get("lang") ?? "en";

    useEffect(() => {
        setWindowWidth(window.innerWidth);

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    var links = [];

    if (lang == 'en') {
        links = [
            { text: '/homepage', url: '/#' },
            { text: '/project-detail', url: '/#projects' },
            { text: '/contact-info', url: '/#contact' },
        ];
    } else {
        links = [
            { text: '/strona-glowna', url: '/#' },
            { text: '/szczegoly-projektow', url: '/#projects' },
            { text: '/kontakt', url: '/#contact' },
        ];
    }

    if (windowWidth >= 600) {
        return (
            <nav id='navbar'>
                <ScrollToAnchor />
                <ul>
                    {
                        links.map((link, index) => {
                            const url = `${link.url.length == 1 ? '' : link.url}/?lang=${lang}`;
                            return (
                                <li key={index}>
                                    <label className="btn" htmlFor="btnControl">
                                        <a className='aHoverable' href={url}>{link.text}</a>
                                    </label>
                                </li>
                            );
                        })
                    }
                </ul>
            </nav>
        );
    } else if (hamburgerVisibe) {
        return (
            <nav id='navbar'>
                <ScrollToAnchor />
                <div>
                    <ul id='homepage-nav-button-ul'>
                        <li>
                            <input type="checkbox" id="btnControl" onClick={() => { switchHamburgerVisibility(false); }} />
                            <label htmlFor="btnControl">
                                <img id='hamburger-menu-icon' src={hamburgerMenu} alt='menu' />
                            </label>
                        </li>
                    </ul>
                    <ul className='ulMargin'>
                        {
                            links.map((link, index) => {
                                const url = `${link.url.length == 1 ? '' : link.url}/?lang=${lang}`;
                                return (
                                    <li key={index}>
                                        <label className="btn" htmlFor="btnControl">
                                            <a href={url}>{link.text}</a>
                                        </label>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </nav>
        );
    } else {
        return (
            <nav id='navbar'>
                <ScrollToAnchor />
                <div>
                    <ul id='homepage-nav-button-ul'>
                        <li>
                            <input type="checkbox" id="btnControl" onClick={() => { switchHamburgerVisibility(true); }} />
                            <label htmlFor="btnControl">
                                <img id='hamburger-menu-icon' src={hamburgerMenu} alt='menu' />
                            </label>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
};

export default Navbar;
